import { Card, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import CardYear from './CardYear';
import PieDonutChart from '../Chart/PieDonutChart';
import MultiValueLineChart from '../Chart/MultiValueLineChart';
import IncomeTypeStackChart from '../Chart/IncomeTypeStackChart';
import YearTwoLevelPieChart from '../Chart/YearTwoLevelPieChart';
import { useContext } from 'react';
import BarLineChart from '../Chart/BarLineChart';
import { numberFormatterLocale } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import ClusterPieChart from '../Chart/ClusterPieChart';
import { ProviderIncomeDashboard } from '../IncomeDashboard';

const IncomeYear = () => {

    const {
        objYear,
        rYear
    } = useContext(ProviderIncomeDashboard);

    const nYear = parseInt(rYear);

    return (
        <Grid container spacing={2} justifyContent={"center"} style={{ padding: "2%" }}>
            <Grid item xs={12} md={10}>
                <Card className='card-label-year'>
                    <Typography className='label-dash-head'>ข้อมูลกา​รเก็บรายได้พิพิธภัณฑ์กรมทรัพยากรธรณี ปีบัญชี {nYear+543}</Typography>
                </Card>
            </Grid>
            <Grid item xs={12} ></Grid>
            <Grid item xs={12} >
                <Grid container spacing={2} justifyContent={"center"}>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <CardYear value={objYear.nPlanInYear} nType={1} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <CardYear value={objYear.nActualInYear} nType={2} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <CardYear value={objYear.rationActulPlan} nType={3} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <CardYear value={objYear.nTotalExpectInYear} nType={4} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} ></Grid>
            <Grid item xs={12} ></Grid>
            <Grid item xs={12} md={6}>
                <PieDonutChart data={objYear.lstPiePlanSeries} year={"key"} />
            </Grid>
            {
                objYear.lstYearTwoLevel.length === 0 ?
                        <Grid item xs={12} md={6}>
                            <YearTwoLevelPieChart
                                dataSeries1={[]}
                                dataSeries2={[]}
                                year={"2566"}
                            />
                        </Grid>
                    :
                    <>
                        {
                            objYear.lstYearTwoLevel.map(item => {
                                return (
                                    <Grid key={"year2-level-" + item.nYear} item xs={12} md={6}>
                                        <YearTwoLevelPieChart
                                            dataSeries1={item.lstPieSeries1}
                                            dataSeries2={item.lstPieSeries2}
                                            year={"2566"}
                                        />
                                    </Grid>
                                )
                            })
                        }
                    </>

            }
            <Grid item xs={12} >
                <MultiValueLineChart
                    keyId={"line"}
                    title={""}
                    data={objYear.lstPlanActualExpect}
                    xAxis={"sMonth"}
                    lstRenderLine={[
                        { field: "nTotalPlan", name: "รายได้ตามแผน" },
                        { field: "nTotalExpect", name: "ประมาณการรายได้" },
                        { field: "nTotalActual", name: "รายได้รวม" },
                    ]}
                />
            </Grid>
            <Grid item xs={12} >
                <IncomeTypeStackChart
                    data={objYear.lstYearTypeIncome}
                    xAxis={"sMonth"}
                />
            </Grid>
            <Grid item xs={12} >
                {
                    (objYear.lstMuseumBarLine || []).map(item => {
                        return (
                            <BarLineChart
                                key={item.sMuseum}
                                year={nYear}
                                keyId={item.nMuseumId}
                                title={item.sMuseum}
                                data={item.lstDataInMonth}
                                sColor ={item.sColor}
                            />
                        );
                    })
                }
            </Grid>
            <Grid item xs={12} >
                <TableContainer id='table-pinned-dashboard' component={Paper}>
                    <Table sx={{ minWidth: 1000 }} >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' sx={{ minWidth: '60px', width: '60px', backgroundColor: '#5598fc !important', color: "#ffffff" }}> </TableCell>
                                <TableCell component="th" padding='none' sx={{ backgroundColor: '#5598fc !important', color: "#ffffff" }}>ชื่อพิพิธภัณฑ์ </TableCell>
                                <TableCell component="th" padding='none' sx={{ minWidth: '200px', width: '200px', backgroundColor: '#5598fc !important', color: "#ffffff" }}>รายได้ตามแผน </TableCell>
                                <TableCell component="th" padding='none' sx={{ minWidth: '200px', width: '200px', backgroundColor: '#5598fc !important', color: "#ffffff" }}>รายได้รวม</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                objYear.lstTableYear.map((item, index) => {
                                    return (
                                        <TableRow key={`rowHead_${index}`} style={{ backgroundColor: "#fff0e6" }}>
                                            <TableCell padding='none' align='center'>{index + 1}</TableCell>
                                            <TableCell padding='none' align='left'>{item.sMuseum}</TableCell>
                                            <TableCell padding='none' align='right'>{item.nPlan === 0 ? 0 : numberFormatterLocale(item.nPlan, 2)}</TableCell>
                                            <TableCell padding='none' align='right'>{item.nActual === 0 ? 0 : numberFormatterLocale(item.nActual, 2)}</TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item xs={12} >
                {
                    (objYear.lstMuseumTicket || []).map(item => {
                        return (
                            <ClusterPieChart
                                key={item.sMuseum}
                                year={nYear}
                                keyId={item.nMuseumId}
                                title={item.sMuseum}
                                dataCluster={item.lstDataMonth}
                                dataPie={item.lstDataPie}
                            />
                        );
                    })
                }
            </Grid>
        </Grid>
    )
}

export default IncomeYear